import { Form, Modal } from "react-bootstrap"; //FloatingLabel
import { Uploader, Button } from "rsuite";
import 'rsuite/Divider/styles/index.css';
import 'rsuite/Uploader/styles/index.css';
import { useFormik, FormikProvider } from "formik";
import {useState, useEffect, useRef} from "react";
import Prioridad from "../../components/catalogo/Prioridad";
import EstatusTask from "../../components/catalogo/EstatusTask";
import dayjs from "dayjs";
import es from "dayjs/locale/es";
import { InicioProyectado, FinProyectado, Recordatorio, Usuarios, Roles } from "../../components/catalogo/CatalogosTareas";
import { useToast } from "../../components/notificaciones/ToastProvider";
import { formValidacion } from "./validaciones/todoValidacion";
import {axiosInstance} from "../../components/helpers/axiosInstance";
import TitleTooltip from "../../components/helpers/TitleTooltip";
import MiembrosMap from "../../components/helpers/MiembrosMap";
import ErrorMessage from "../../components/helpers/ErrorMessage";

///// Fecha default de calendario /////
const today = new Date();
/**
 *
 * @param idParent (Solo cuando es subtarea)
 * @param showForm
 * @param setShowForm
 * @returns {JSX.Element}
 * @constructor
 */
export default function FormTarea({
    idParent,
    showForm,
    setShowForm
}) {
    ///// Manejo de pasos de formulario /////
    const [step, setStep] = useState(0);
    ///// Guardar archivos de tarea /////
    const [fileList, setFileList] = useState([]);
    ///// Datos de usuario /////
    const auth = JSON.parse(sessionStorage.getItem("user"));
    ///// Manejar modal de usuarios /////
    const [addMember, setAddMember] = useState(false);
    ///// Guardar miembros de tarea /////
    const [members, setMembers] = useState([]);
    ///// Hook (propio) manejo de notíficaciones  /////
    const toast = useToast();
    ///// Usuarios /////
    const datosMiembros = localStorage.getItem('miembros') ? JSON.parse(localStorage.getItem('miembros')) : null;
    dayjs.locale(es);

    ///// Valor inicial de formulario /////
    const valorInical = {
        id_parent: idParent,
        flujo: "Tarea",
        tarea: "",
        objetivo: "",
        notas: "",
        prioridad: "N",
        recordatorio: today,
        inicio_proyectado: today,
        termino_proyectado: today,
        id_estatus: 1,
        creada_por: auth.usuario.usuario,
        miembros:  [],
        archivos: []
    }


    ///// Enviar datos al servidor /////
    function onSubmit(values){

        axiosInstance.post('/todo/tareas/', values)
            .then((res) => {
                if (res.status === 200){
                    ///// Notificación : se envio correctamente /////
                    toast.setArrayToast(
                        prevState => [
                            ...prevState,
                            {
                                id : 'tareaNueva',
                                text : 'La tareas:' + values.tarea + 'se ha creado correctamente',
                                color : 'success',
                                show : true
                            }
                        ]
                    );
                    handleCloseForm();
                }
            }).catch((err) => {
                ///// Notificación : envio rechazado /////
                toast.setArrayToast(
                    prevState => [
                        ...prevState,
                        {
                            id : 'tareaNuevaError',
                            text : 'Hay un error con los datos:' + err.data,
                            color : 'danger',
                            show : true

                        }
                    ]
                )
        });
    }

    ///// Manejo de formulario /////
    const formik = useFormik({
        initialValues : valorInical,
        validationSchema : formValidacion[step],
        enableReinitialize : true,
        onSubmit
    });

    ///// Agregar usuario al array de miembros de formik /////
    const { setFieldValue } = formik;
   useEffect(() => {
       if(members.length > 0){
           setFieldValue('miembros', members);
       }
    }, [members, setFieldValue]);

    ///// Agregar los archivos cargados con el formto pedido /////
   useEffect(() => {
       if(fileList.length > 0){
           const array =  [];
           fileList.forEach((f) => {
               const reader = new FileReader();
               reader.onload = () => {
                   array.push({
                       filename: f?.name,
                       filetype: f?.blobFile.type,
                       content: reader?.result.replace('data:', '').replace(/^.+,/, ''),
                   })
               }
               reader.readAsDataURL(f.blobFile);
           })
           setFieldValue('archivos', array);
       }
    }, [fileList, setFieldValue]);

    ///// Regresar los estados al valor inicial /////
    function handleCloseForm(){
        setShowForm(false);
        formik.resetForm();
        setMembers([]);
        setFileList([]);
        setStep(0);
        //
        formik.resetForm();
    }

    formik.values.miembros = members;
   // formik.values.archivos = allFiles;

    //background-color : #e5f1ff;
    //'bg-light-primary
    return (
        <>
            <style type={'text/css'}>
                {`
                    .rs-picker-popup{
                        z-index: 1046;
                    }
                    
                    .rs-input{
                        text-transform: capitalize;
                        cursor: pointer;
                        color: #068099;
                    }
                    
                `}
            </style>
            <Modal show={showForm} fullscreen={true} onHide={handleCloseForm} contentClassName={'justify-content-center'}>
                <Modal.Header closeButton tabIndex={-1}>
                    <div className="d-flex justify-content-center align-items-center">
                        <i className="ki-duotone ki-notepad-edit fs-3x text-primary">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                        <span className="modal-title h3 ps-2"> Crear nueva tarea </span>
                    </div>
                </Modal.Header>
                <Modal.Body className={"py-7 align-content-center"}>
                    <div className={"container d-grid d-md-flex align-items-center justify-content-center"}>
                        <DatosTarea formik={formik} step={step} members={members} datosMiembros={datosMiembros} setAddMember={setAddMember} fileList={fileList} setFileList={setFileList}></DatosTarea>
                    </div>
                </Modal.Body>
                <Modal.Footer className={"d-flex"}>
                    <button type={'button'} className={"btn btn-secondary me-5"} onClick={handleCloseForm}>
                        Cancelar
                    </button>
                    {
                        step > 0 ? (<div className="mr-2">
                            <button type="button" className="btn btn-light-primary me-3"
                                    onClick={() => setStep(step - 1)}
                            >
                                <i className="ki-duotone ki-arrow-left fs-4 rotate-180">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                                Atras
                            </button>
                        </div>) : (<div></div>)
                    }
                    <div>
                        <button form={"crearTarea"} type={'submit'} className={"btn btn-primary me-3 " + (step < 1 && "d-none" )}
                                disabled={Object.keys(formik.errors).length > 0}
                        >
                            <span className="indicator-label"> Enviar
                                <i className="ki-duotone ki-arrow-right fs-4 ms-2 me-0">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </span>
                        </button>
                        <button type="button" className={"btn btn-primary " + (step === 1 && "d-none")} onClick={() => setStep(step + 1)}
                            //nextStep
                                disabled={Object.keys(formik.errors).length > 0}
                        >
                            Continuar
                            <i className="ki-duotone ki-arrow-right fs-4 ms-1 me-0">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Miembros valuesParent={formik.values.miembros} setAddMember={setAddMember} addMember={addMember}
                      members={members} setMembers={setMembers} datosMiembros={datosMiembros}></Miembros>
        </>
    );
}

/**
 *
 * @param formik
 * @param step
 * @param members
 * @param datosMiembros
 * @param setAddMember
 * @param fileList
 * @param setFileList
 * @returns {JSX.Element}
 * @constructor
 */
function DatosTarea({
    formik,
    step,
    members,
    datosMiembros,
    setAddMember,
    fileList,
    setFileList
}){

    const tituloRef = useRef(null);
    const uploader = useRef();

    const { validateForm } = formik;

    useEffect(() => {
        if (tituloRef.current) {
            tituloRef.current.focus();
            validateForm();
        }
    },[validateForm]);

    return(
        <div className="content d-flex flex-column flex-column-fluid" id={"alta-tarea"}>
            <div className={"stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid gap-10"}>
                <div className={"card card-bordered d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px"}>
                    <div className={"card-body px-6 px-lg-10 px-xxl-15 py-20"}>
                        <div className={"stepper-nav"}>
                            <div className={"stepper-item " + (step === 0 ? "current" : step > 0 ? "completed" : "")}>
                                <div className="stepper-wrapper">
                                    <div className="stepper-icon w-40px h-40px">
                                        <i className="ki-duotone ki-check fs-2 stepper-check"></i>
                                        <span className="stepper-number">1</span>
                                    </div>
                                    <div className="stepper-label">
                                        <h3 className="stepper-title">Tarea</h3>
                                        <div className="stepper-desc fw-semibold">Datos generales de la nueva tarea</div>
                                    </div>
                                </div>
                                <div className="stepper-line h-40px"></div>
                            </div>
                            <div className={"stepper-item " + (step === 1 ? "current" : step > 1 ? "completed" : "")}>
                                <div className="stepper-wrapper">
                                    <div className="stepper-icon w-40px h-40px">
                                        <i className="ki-duotone ki-check fs-2 stepper-check"></i>
                                        <span className="stepper-number">2</span>
                                    </div>
                                    <div className="stepper-label">
                                        <h3 className="stepper-title">Archivos adjuntos</h3>
                                        <div className="stepper-desc fw-semibold">Documentos necesarios para tarea</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'card card-bordered d-flex flex-row-fluid flex-center'}>
                    <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit} className={"card-body w-100 mw-xl-1000px px-9"} id={'crearTarea'}>
                            <div className={step === 0 ? "current" : ""} data-kt-stepper-element="content">
                                <div className={"w-100 p-9"}>
                                    <div className={"row"}>
                                        <div className={"col-md"}>
                                            <Prioridad setFieldValue={formik.setFieldValue} values={formik.values.prioridad} edit={true}></Prioridad>
                                            <ErrorMessage name={'prioridad'}></ErrorMessage>
                                        </div>
                                        <div className={"col-md"}>
                                            <InicioProyectado setFieldValue={formik.setFieldValue}
                                                              defaultV={formik.values.inicio_proyectado}
                                                              edit={true}></InicioProyectado>
                                            <ErrorMessage name={'inicio_proyectado'}></ErrorMessage>
                                        </div>
                                        <div className={"col-md"}>
                                            <FinProyectado setFieldValue={formik.setFieldValue}
                                                           defaultV={formik.values.termino_proyectado}
                                                           disableValue={formik.values.inicio_proyectado}
                                                           edit={true}></FinProyectado>
                                            <ErrorMessage name={'termino_proyectado'}></ErrorMessage>
                                        </div>
                                        <div className={"col-md"}>
                                            <Recordatorio setFieldValue={formik.setFieldValue}
                                                          defaultV={formik.values.recordatorio}
                                                          disableValue={formik.values.inicio_proyectado}
                                                          edit={true}></Recordatorio>
                                            <ErrorMessage name={'recordatorio'}></ErrorMessage>
                                        </div>
                                    </div>
                                    <div className={"row"}>
                                        <div className={"col-md-2"}>
                                            <EstatusTask setFieldValue={formik.setFieldValue} values={formik.values.id_estatus}
                                                         edit={true}></EstatusTask>
                                            <ErrorMessage name={'id_estatus'}></ErrorMessage>
                                        </div>
                                        <div className={"col-md-10"}>
                                            <div className={'form-floating'}>
                                                <input
                                                    ref={tituloRef}
                                                    className={"form-control form-control-solid text-uppercase"}
                                                    type="text"
                                                    id="tarea"
                                                    name={"tarea"}
                                                    placeholder={"Título de tarea"}
                                                    value={formik.values.tarea}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                <label htmlFor={'tarea'} className={'text-gray-700'}>Título de tarea</label>
                                            </div>
                                            <ErrorMessage name={'tarea'}></ErrorMessage>
                                        </div>
                                    </div>
                                    <div className={"row"}>
                                        <div className={"col-md-9"}>
                                            <div className={"form-floating"}>
                                        <textarea
                                            className={"form-control form-control-solid text-uppercase"}
                                            placeholder="Descripción"
                                            style={{height: '75px', resize: 'none'}}
                                            name={"objetivo"}
                                            value={formik.values.objetivo}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        ></textarea>
                                                <label htmlFor={'objetivo'} className={'text-gray-700'}>Objetivo</label>
                                            </div>
                                            <ErrorMessage name={'objetivo'}></ErrorMessage>
                                        </div>
                                        <div className={"col-md-3 align-self-end"}>
                                            {
                                                members && members.length > 0 ? (
                                                    <div className="symbol-group symbol-hover py-1">
                                                        {
                                                            members.map((m, index) => {
                                                                const data = datosMiembros.filter((mm) => mm.id_usuario === m.id_usuario);
                                                                return ( index < 4 && <MiembrosMap key={m.id_miembro} user={data[0].usuario} avatar={data[0].avatar}></MiembrosMap>);
                                                            })
                                                        }
                                                        <TitleTooltip title="Todo los miembros" placement={'top'}>
                                                            <button type={'button'}
                                                                    className="btn p-0 symbol symbol-30px symbol-circle"
                                                                    onClick={() => setAddMember(true)}>
                                                                <span className="symbol-label fs-8 fw-bold bg-dark text-white"> + </span>
                                                            </button>
                                                        </TitleTooltip>
                                                    </div>
                                                ) : (
                                                    <div className={"d-flex justify-content-end"}>
                                                        <button className={"btn btn-outline btn-outline-primary btn-active-light-primary"}
                                                                onClick={() => setAddMember(true)}
                                                                type={'button'}> Agregar miembros
                                                        </button>
                                                    </div>
                                                )
                                            }
                                            <ErrorMessage name={'miembros'}></ErrorMessage>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={step === 1 ? "current" : ""} data-kt-stepper-element="content">
                                <div className={"w-100 p-9"}>
                                    <Uploader ref={uploader} action={""} fileList={fileList} multiple={true} autoUpload={false} onChange={setFileList} draggable={true}>
                                        <div style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: "var(--bs-primary-light)", marginBottom: "1.75rem", borderRadius: ".475rem"}}>
                                            <span> Has click o arrastra los archivos</span>
                                        </div>
                                        {/*<Button type={'button'} className={"btn btn-icon btn-bg-light btn-active-color-primary btn-sm"}><i className="bi bi-paperclip" style={{color: "#0076bc"}}></i></Button>*/}
                                    </Uploader>
                                    <div className={"form-floating"}>
                                        <textarea
                                            className={"form-control form-control-solid text-uppercase"}
                                            placeholder="Notas adicionales"
                                            style={{height: '50px', resize: 'none'}}
                                            name={"notas"}
                                            value={formik.values.notas}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        ></textarea>
                                        <label htmlFor={'notas'} className={'text-gray-700'}>Notas</label>
                                    </div>
                                    <ErrorMessage name={'notas'}></ErrorMessage>
                                </div>
                            </div>
                        </form>
                    </FormikProvider>
                </div>
            </div>
        </div>
    );
}

/**
 *
 * @param addMember
 * @param setAddMember
 * @param members
 * @param setMembers
 * @param datosMiembros
 * @returns {JSX.Element}
 * @constructor
 */
function Miembros({
  addMember,
  setAddMember,
  members,
  setMembers,
  datosMiembros
}){
    const valorInicial = {
        id_usuario: null,
        rol: null
    }

    function onSubmit(values){
        setMembers([
            ...members,
            values
        ]);
        formikM.resetForm();
    }

    const formikM = useFormik({
        initialValues: valorInicial,
        onSubmit
    });

    function deleteMember(id) {
        setMembers(members.filter(m => m.id_usuario !== id));
    }

    function handleClose(){
        formikM.resetForm();
        setAddMember(false);
    }

    return (
        <>
            <style type={'text/css'}>
                {`
                    // .rs-picker-popup{
                    //     z-index: 1060;
                    // }
                `}
            </style>
            <Modal show={addMember} onHide={() => handleClose()} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div className="d-flex justify-content-center align-items-center">
                            <i className="ki-solid ki-address-book fs-2qx text-primary "></i>
                            <span className="modal-title h3 ps-2"> Agregar usuario </span>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mh-375px scroll-y me-n7 pe-7 mb-3">
                        {
                            members && members.map((m) => {
                                const data = datosMiembros.filter((mm) => mm.id_usuario === m.id_usuario);
                                return (
                                    <div key={m.id_usuario}
                                         className="d-flex flex-stack py-3 border-bottom border-gray-300 border-bottom-dashed">
                                        <div className="d-flex align-items-center">
                                            <div className="symbol symbol-35px symbol-circle">
                                                <span
                                                    className={"symbol-label fw-semibold " + data[0].avatar}>{data[0].avatar}</span>
                                            </div>
                                            <div className="ms-6">
                                                <button
                                                    className="btn p-0 d-flex align-items-center fs-5 fw-bold text-gray-900 text-hover-primary text-capitalize"
                                                    type={'button'}>
                                                    {data[0].usuario}
                                                    <span
                                                        className="badge badge-light fs-8 fw-semibold ms-2">{m.rol}</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div className="text-end">
                                                <button
                                                    type={'button'}
                                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                                    onClick={() => deleteMember(m.id_usuario)}>
                                                    <i className="ki-duotone ki-trash fs-2">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                        <span className="path3"></span>
                                                        <span className="path4"></span>
                                                        <span className="path5"></span>
                                                    </i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>

                    <Form onSubmit={formikM.handleSubmit} className={'d-flex row justify-content-around'} id={"add-miembro"}>
                        <div className={'col-md-5'}>
                            <Usuarios setFieldValue={formikM.setFieldValue} values={formikM.values.id_usuario}
                                      disableOpc={members}></Usuarios>
                        </div>
                        <div className={'col-md-5'}>
                            <Roles setFieldValue={formikM.setFieldValue} values={formikM.values}></Roles>
                        </div>
                        <div className={'col-md-2 align-content-center'}>
                            <button className={"btn btn-outline btn-outline-primary btn-active-light-primary p-2 fs-7"}
                                    style={{height: "fit-content", alignSelf: "end"}} type={'submit'} form={'add-miembro'}
                                    disabled={formikM.values.rol === null || formikM.values.id_usuario === null}>Agregar</button>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button type={'button'} variant={'secondary'} onClick={() => handleClose()}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
